export default __webpack_public_path__ + "static/media/100_39257.21b4aa24.jpg";